// Shared color ramps for the deals map. Single source of truth so the map
// choropleth and the legend overlay never drift apart.
//
// COUNTY_RAMP_STOPS — used for the active-deal-count choropleth on counties.
// Mapbox 'case' wraps these for zero counts (transparent). Stops are at
// fractional positions of the dynamic max:
//   1 (any deals at all)  -> #ffeda0  (yellow)
//   25%  of max           -> #feb24c  (orange-yellow)
//   56%  of max           -> #fd8d3c  (orange)
//   100% of max           -> #bd0026  (red)
export const COUNTY_RAMP_STOPS = [
  { fraction: null, color: "#ffeda0", label: "min" }, // count == 1 floor
  { fraction: 0.25, color: "#feb24c" },
  { fraction: 0.5625, color: "#fd8d3c" },
  { fraction: 1, color: "#bd0026", label: "max" },
];

// SECTION_RAMP_STOPS — used for the section-level choropleth (deal count per
// PLSS section). White-blue ramp, fractional-of-max stops.
export const SECTION_RAMP_STOPS = [
  { fraction: 0, color: "#f7fbff" },
  { fraction: 0.25, color: "#c6dbef" },
  { fraction: 0.5, color: "#6baed6" },
  { fraction: 0.75, color: "#2171b5" },
  { fraction: 1, color: "#08306b" },
];

// Convenience export — flat array of just the colors for the county ramp,
// in display order (zero/transparent first, then ramp from low->high).
export const COUNTY_RAMP_COLORS = COUNTY_RAMP_STOPS.map((s) => s.color);

// OCC unit overlays — one outline color per unit kind, keyed by the API's
// `kind` value. Chosen to stay clear of the blue section ramp and the
// yellow-red county ramp (which has faded out by the time units matter).
export const OCC_KIND_COLORS = {
  pooling: "#7b3294",
  spacing: "#1b9e77",
  increased_density: "#e66101",
  location_exception: "#d01c8b",
};

// OCC intents to drill (well permits) — one circle color for every permit
// point. Red, clear of the OCC kind outlines (purple/green/orange/magenta),
// the blue section ramp and the tract bucket fills (the yellow-red county
// ramp is not drawn on the deal map); drawn with a white stroke.
export const OCC_INTENT_COLOR = "#e31a1c";

// Aliquot (quarter-call) tract shapes, filled by deal-status bucket
// (utils/tractStatusBucket). Dead is a flat grey.
export const TRACT_BUCKET_COLORS = {
  early: "#fde68a",
  negotiating: "#fb923c",
  committed: "#2563eb",
  ours: "#16a34a",
  dead: "#9e9e9e",
};
export const TRACT_LINE_COLOR = "#3e2723";
